var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_core.js